import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  private storage: Storage;

  constructor() {
    this.storage = localStorage;
  }

  get(key: string): any {
    const item = this.storage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  set(key: string, value: any): void {
    this.storage.setItem(key, JSON.stringify(value));
  }

  update(key: string, value: any): void {
    if (this.storage.getItem(key)) {
      this.set(key, value);
    }
  }

  delete(key: string): void {
    this.storage.removeItem(key);
  }
}
